export const storageAccessTokenKey = "of-storage-access-token"
export const storageRefreshTokenKey = "of-storage-refresh-token"
export const storageExpiresIn = "of-storage-expires-in"
export const storageIsLogged = "of-storage-is-logged"
export const storageUserInfo = "of-storage-user-info"

export let timeoutRefresh: any

export function expiresIn(): number {
	return Number(localStorage.getItem(storageExpiresIn))
}

export const accessToken = localStorage.getItem(storageAccessTokenKey)

export function saveToLocalStorage(res: any) {
	localStorage.setItem(storageAccessTokenKey, res.access_token)
	localStorage.setItem(storageRefreshTokenKey, res.refresh_token)
	const expiresInValue = String(new Date().valueOf() + res.expires_in * 0.95 * 1000)
	localStorage.setItem(storageExpiresIn, expiresInValue)
	localStorage.setItem(storageIsLogged, "1")
	if (res.roles && res.roles.length) {
		localStorage.setItem(storageUserInfo, JSON.stringify(res.roles))
	}
}

export function clear() {
	localStorage.removeItem(storageAccessTokenKey)
	localStorage.removeItem(storageRefreshTokenKey)
	localStorage.removeItem(storageExpiresIn)
}
